export default __webpack_public_path__ + "static/media/SignikaNegative-Regular.037bfe66.ttf";